import { render, staticRenderFns } from "./booth_card.vue?vue&type=template&id=dd1cb9c4&scoped=true"
import script from "./booth_card.vue?vue&type=script&lang=js"
export * from "./booth_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1cb9c4",
  null
  
)

export default component.exports